import {
    validateSingleSelection,
    validateContactNumber,
    validateBranchCode,
    validateAccountNumber,
    validateDate,
} from '@om/validation';
import {
    setPhoneNumberValid,
    PHONE_NUMBER_SET_VALUE,
    setTermsValid,
    TERMS_SET_VALUE,
    setNetworkProviderValid,
    SET_NETWORK_PROVIDER,
    setAccountHolderNameValid,
    ACCOUNT_HOLDER_NAME_SET_VALUE,
    setAccountHolderSurnameValid,
    ACCOUNT_HOLDER_SURNAME_SET_VALUE,
    setPaymentMethodValid,
    PAYMENT_METHOD_SET_VALUE,
    setBankNameValid,
    BANK_NAME_SET_VALUE,
    setBranchCodeValid,
    BRANCH_CODE_SET_VALUE,
    setAccountNumberValid,
    ACCOUNT_NUMBER_SET_VALUE,
    setAccountTypeValid,
    ACCOUNT_TYPE_SET_VALUE,
    setDebitDayValid,
    DEBIT_DAY_SET_VALUE,
} from '../../../actions/naMotorInsurance/payments';
import { validationIsEqual } from '../status';
import { validateGenericString, validateName } from '@om/validation/src/validators/string-validator';
import { validateGenericNumber, validateNumber } from '@om/validation/src/validators/number-validator';

let prevValidationAction = null;

export const paymentsFormValidation = (store, next, action) => {
    const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Payments Phone Number',
                    countryCode: gatsbyStack,
                });
                return setPhoneNumberValid(error);

            case TERMS_SET_VALUE:
                error = validateSingleSelection(action.value, 'Terms');
                return setTermsValid(error);

            case SET_NETWORK_PROVIDER:
                error = validateSingleSelection(action.value, 'Network Provider');
                return setNetworkProviderValid(error);

            case ACCOUNT_HOLDER_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 4,
                    subject: 'Account holder name',
                });
                return setAccountHolderNameValid(error);

            case ACCOUNT_HOLDER_SURNAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 4,
                    subject: 'Account holder surname',
                });
                return setAccountHolderSurnameValid(error);

            case PAYMENT_METHOD_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Payment method',
                });
                return setPaymentMethodValid(error);

            case BANK_NAME_SET_VALUE:
                error = validateGenericString(action.value, {
                    subject: 'Bank name',
                });
                return setBankNameValid(error);

            case BRANCH_CODE_SET_VALUE:
                error = validateBranchCode(action.value);
                return setBranchCodeValid(error);

            case ACCOUNT_NUMBER_SET_VALUE:
                error = validateAccountNumber(action.value);
                return setAccountNumberValid(error);

            case ACCOUNT_TYPE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Account type',
                });
                return setAccountTypeValid(error);

            case DEBIT_DAY_SET_VALUE:
                error = validateNumber(action.value, {
                    min: 1,
                    max: 31,
                    subject: 'Debit day',
                });
                return setDebitDayValid(error);

            default:
                return null;
        }
    })();
    if (!validationAction || (validationIsEqual(validationAction, prevValidationAction) && action.value.length > 1)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
